import React from 'react';
import { Box, Breadcrumbs as MaterialBreadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router';

import { Breadcrumb } from '../../selectors/breadcrumbsSelector';

function generateLink(crumbs: Breadcrumb[]) {
  const lastCrumb = crumbs[crumbs.length - 1];

  switch (lastCrumb.type) {
    case 'directory':
      return `/directories/${lastCrumb.guid}`;

    case 'line':
      return `/lines/${lastCrumb.guid}`;

    case 'station':
      const nextToLastCrumb = crumbs[crumbs.length - 2];

      return nextToLastCrumb?.type === 'line'
        ? `/lines/${nextToLastCrumb.guid}/stations/${lastCrumb.guid}`
        : `/stations/${lastCrumb.guid}`;
  }
}

export function Breadcrumbs(props: { crumbs: Breadcrumb[]; disableLinks?: boolean; omitSelf?: boolean }) {
  const crumbElements = [];
  const cumulativeCrumbs = [];

  for (const crumb of props.crumbs.slice(0, -1)) {
    cumulativeCrumbs.push(crumb);

    crumbElements.push(
      <Typography
        key={crumb.guid}
        variant="body2"
        sx={{ color: 'text.secondary' }}
        {...(props.disableLinks
          ? {}
          : {
              component: Link,
              to: generateLink(cumulativeCrumbs),
              sx: { textDecoration: 'none', '&:hover': { textDecoration: 'underline' } },
            })}
      >
        {crumb.name}
      </Typography>,
    );
  }

  if (!props.omitSelf) {
    const selfCrumb = props.crumbs[props.crumbs.length - 1];

    crumbElements.push(
      <Typography variant="body2" sx={{ color: 'text.secondary' }} key="self">
        {selfCrumb.name}
      </Typography>,
    );
  }

  return (
    <Box sx={{ marginBottom: 1 }}>
      <MaterialBreadcrumbs>{crumbElements}</MaterialBreadcrumbs>
    </Box>
  );
}
